import React from 'react';
import { ORIENTACIONES, TIPO_LABELS } from '../data/orientaciones';

export default function OrientacionPanel({ tipo }) {
  const o = ORIENTACIONES[tipo];
  if (!o) return null;
  return (
    <div className="orientacion-panel">
      <div className="orientacion-title">{TIPO_LABELS[tipo]}</div>
      <div className="orientacion-encargado">Instancia responsable: {o.encargado}</div>
      <div className="orientacion-base">Base legal: {o.baseLegal}</div>
      <div className="orientacion-pasos">
        {o.pasos.map((paso, i) => (
          <div key={i} className="orientacion-paso">
            <div className="paso-num">{i + 1}</div>
            <div className="paso-txt">{paso}</div>
          </div>
        ))}
      </div>
      {o.docs && (
        <div className="orientacion-docs">
          <div className="docs-title">Documentos requeridos:</div>
          {o.docs.map((doc, i) => <div key={i} className="doc-item">• {doc}</div>)}
        </div>
      )}
    </div>
  );
}